import { useState } from 'react';
import './App.css';
import Login from './pages/Login';
import PhysicalMail from './pages/PhysicalMail';
import Payments from './pages/Payments';
import UserManagement from './pages/UserManagement';
import ContentManagement from './pages/ContentManagement';

const TABS = [
  { key: 'physical-mail', label: '실물 우편' },
  { key: 'payments', label: '거래 내역 / 환불' },
  { key: 'users', label: '사용자 관리' },
  { key: 'content', label: 'FAQ / 공지' },
];

function App() {
  const [token, setToken] = useState(localStorage.getItem('adminToken') || '');
  const [activeTab, setActiveTab] = useState('physical-mail');

  const handleLogin = (pw) => {
    localStorage.setItem('adminToken', pw);
    setToken(pw);
  };

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    setToken('');
  };

  if (!token) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <div className="App">
      <header className="header">
        <h1>나중편지 관리자</h1>
        <nav className="tab-nav">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              className={`tab-btn ${activeTab === tab.key ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </nav>
        <button onClick={handleLogout} className="logout-btn">로그아웃</button>
      </header>
      {activeTab === 'physical-mail' && <PhysicalMail token={token} />}
      {activeTab === 'payments' && <Payments token={token} />}
      {activeTab === 'users' && <UserManagement token={token} />}
      {activeTab === 'content' && <ContentManagement token={token} />}
    </div>
  );
}

export default App;
